import React from 'react';
import SelectEntityOption from '../components/SelectEntityOption';
import LocalSearchHighlight from '../search/LocalSearchHighlight';
import { GroupMatchKey } from '../search/entitySearch/localEntitySearch';
import type { FuzzySearchMatch } from '../utils/search/fuzzySearch';
import GroupIcon from './GroupIcon';

interface GroupSelectOptionProps {
  group: { name: string };
  matches?: readonly FuzzySearchMatch[];
}

const GroupSelectOption = React.forwardRef<
  HTMLDivElement,
  GroupSelectOptionProps
>(({ group, matches, ...props }: GroupSelectOptionProps, ref) => (
  <SelectEntityOption
    {...props}
    icon={<GroupIcon />}
    label={
      <LocalSearchHighlight
        matches={matches}
        matchKey={GroupMatchKey.Name}
        defaultValue={group.name}
      />
    }
    ref={ref}
  />
));

export default GroupSelectOption;
